import(/* webpackMode: "eager" */ "/vercel/path0/src/app/footer/independent-teachers/page.js");
